import store from '@/store'

export const LANDSCAPE_TEXT_POPUP_MAX_HEIGHT = 600

let baseWidth = typeof window !== 'undefined' ? window.innerWidth : 0
let baseHeight = typeof window !== 'undefined' ? window.innerHeight : 0

function refreshViewportBaseline() {
    if (typeof window === 'undefined') {
        return
    }

    const w = window.innerWidth
    const h = window.innerHeight

    if (w !== baseWidth) {
        baseWidth = w
        baseHeight = h
    } else if (h > baseHeight) {
        baseHeight = h
    }
}

export function isLandscapeOrientation() {
    return window.innerWidth > window.innerHeight
}

export function getScreenDiagonalInches() {
    const sw = Math.max(window.screen.width, window.screen.height)
    const sh = Math.min(window.screen.width, window.screen.height)
    const dpr = window.devicePixelRatio || 1
    const diagonalPx = Math.sqrt(Math.pow(sw * dpr, 2) + Math.pow(sh * dpr, 2))
    const dpi = 160 * dpr
    return diagonalPx / dpi
}

export function isSmallScreenDevice(maxInches = 9) {
    return getScreenDiagonalInches() < maxInches
}

export function getViewportShortSide() {
    refreshViewportBaseline()
    return baseHeight
}

export function isShortScreen(maxHeight = LANDSCAPE_TEXT_POPUP_MAX_HEIGHT) {
    return getViewportShortSide() <= maxHeight
}

export function getPopupTextInputMaxHeight() {
    const configured = Number(store.getters.getPopupTextInputHeight)
    if (!Number.isNaN(configured) && configured > 0) {
        return configured
    }

    return LANDSCAPE_TEXT_POPUP_MAX_HEIGHT
}

export function shouldUseLandscapeTextPopup() {
    return process.env.VUE_APP_IS_APP === 'TRUE' && !!store.getters.getPopupTextInput && isShortScreen(getPopupTextInputMaxHeight())
}

let screenRotationInProgressUntil = 0

export function markScreenRotationInProgress(durationMs = 400) {
    screenRotationInProgressUntil = Date.now() + durationMs
}

export function isScreenRotationInProgress() {
    return Date.now() < screenRotationInProgressUntil
}

let layoutVersion = 0
const subscribers = new Set()
let listenerAttached = false
let debounceTimer = null

function notifyScreenLayoutChange() {
    layoutVersion++
    subscribers.forEach((cb) => cb(layoutVersion))
}

function scheduleScreenLayoutChange() {
    if (debounceTimer) {
        clearTimeout(debounceTimer)
    }

    debounceTimer = setTimeout(() => {
        debounceTimer = null
        notifyScreenLayoutChange()
    }, 100)
}

function onViewportResize() {
    refreshViewportBaseline()
    scheduleScreenLayoutChange()
}

function onOrientationChange() {
    markScreenRotationInProgress()
    scheduleScreenLayoutChange()
}

function attachScreenLayoutListeners() {
    if (listenerAttached || typeof window === 'undefined') {
        return
    }

    listenerAttached = true
    refreshViewportBaseline()
    window.addEventListener('orientationchange', onOrientationChange)
    window.addEventListener('resize', onViewportResize)

    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', onViewportResize)
    }
}

export function subscribeScreenLayoutChange(callback) {
    attachScreenLayoutListeners()
    subscribers.add(callback)

    return () => {
        subscribers.delete(callback)
    }
}

export function getScreenLayoutVersion() {
    return layoutVersion
}
